import { wishlistService } from "./services/wishlist.service";
import { getSizedImageUrl } from "./utils/index";

function setSavedToWishlistButton(set = true) {
  const wishlistButton = document.querySelector('[data-wishlist-modal-open]');

  if (wishlistButton) {
    const textElement = wishlistButton.querySelector('span');

    if (set) {
      wishlistButton.classList.add('added');
      textElement.innerText = 'Saved to Wishlist';
    } else {
      wishlistButton.classList.remove('added');
      textElement.innerText = 'Save to Wishlist';
    }
  }
}

window.addEventListener('DOMContentLoaded', () => {
  const selectedVariantElm = document.querySelector('[data-selected-variant-id]');
  const variantId = selectedVariantElm
    ? Number(selectedVariantElm.dataset.selectedVariantId)
    : null;

  const hasProduct = window.liquid && window.liquid.product;

  wishlistService.getAllWishlists();

  if (hasProduct) {
    const setPageData = (variantId) => {
      const shopifyProduct = window.liquid.product;
      const variant = shopifyProduct.variants.find((variant) => variant.id === Number(variantId));
      const productImage = variant.featured_image
        ? variant.featured_image.src
        : shopifyProduct.featured_image;
      const productImageUrl = getSizedImageUrl(productImage, '620x620');

      const newProductData = {
        et: 1,
        empi: shopifyProduct.id,
        epi: variant.id,
        dt: shopifyProduct.title,
        vi: variant.title,
        du: shopifyProduct.canonical_url,
        ct: shopifyProduct.type,
        pr: variant.price / 100,
        iu: productImageUrl,
        variants: [{ [variant.title]: variant.id }],
        ...(variant.compare_at_price && { op: variant.compare_at_price / 100 }),
      };

      wishlistService.swymLoaded().then(() => {
        Object.assign(SwymPageData, newProductData);
        window._swat.fetch((products) => {
          const isInWishlist = !!products.find(function (p) {
            return p.empi == shopifyProduct.id && p.epi == variant.id;
          });

          if (isInWishlist) {
            setSavedToWishlistButton();
          } else {
            setSavedToWishlistButton(false);
          }
        }, 1);
      });
    };

    setPageData(variantId);

    function swymCallbackFn() {
      const wishlistButton = document.querySelector('[data-wishlist-modal-open]');

      if (wishlistButton) {
        wishlistService.swymLoaded().then(async () => {
          await window._swat.fetch((products) => {
            const activeProductId = SwymPageData.empi;
            const activeVariantId = SwymPageData.epi;
            const isInWishlist = !!products.find(function (p) {
              return p.empi == activeProductId && p.epi == activeVariantId;
            });

            if (isInWishlist) {
              setSavedToWishlistButton();
            }

            $(document).on('click', '.btn-add-to-wishlist', function () {

              if (SwymPageData) {
                var swymPageDataToAdd = Object.assign({}, SwymPageData, { et: 4 });

                if (this.classList.contains('added')) {
                  const deleteConfirmed = confirm(
                    'Are you sure you want to remove this product from wishlist?'
                  );
                  if (deleteConfirmed) {
                    try {
                      window._swat.removeFromWishList(swymPageDataToAdd, function () {
                        setSavedToWishlistButton(false);
                      });
                    } catch (e) {
                      console.error('Error removing item from wishlist');
                    }
                  }
                } else {
                  window._swat.addToWishList(swymPageDataToAdd, function () {
                    setSavedToWishlistButton();
                  });
                }
              }
            });
          }, 4);
        });
      }
    }

    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(swymCallbackFn);
  }

  // const wishlistWrapper = document.getElementById('wishlist__wrapper');

  const wishListPage = {
    enquiryCloseBtn: document.querySelector('[data-wishlist-enquiry-close]'),
    enquirywrapper: document.querySelector('[data-wishlist-enquiry-wrapper]'),
    emptyContainer: document.querySelector('#wishlist-empty-container'),
    wishlistLoading: document.querySelector('#wishlist-loading'),
    container: document.querySelector('#wishlist-container'),
    wishlistSidebar: document.querySelector('#wishlist-sidebar'),
    wishlistResults: document.querySelector('#wishlist__results'),
    wishlistModal: document.querySelector('[data-wishlist-modal]'),
    wishlistModalBody: document.querySelector('#wishlistModal-body'),
    removeWishlistButton: document.querySelector('.wishlist__btn-link--remove'),
    requestQuoteActionWrapper: document.querySelector('#wishlist-request-quote_action-wrapper'),
  };

  const swymActionSelector = {
    enquiryWrapper: '[data-wishlist-enquiry-wrapper]',
    enquiryClose: '[data-wishlist-enquiry-close]',
    requestQuote: '.js-wishlist-request-quote',
    listDelete: '.js-swym-list-delete',
    listRename: '.js-swym-list-rename',
    listRenameCancel: '.js-swym-list-rename-cancel',
    listRenameUpdade: '.js-swym-list-rename-update',
    header: '.js-swym-wishlist__header',
    headerForm: '.js-swym-wishlist__header-form',
  };

  const fetchWishlists = async function () {
    const wishlistData = {};
    const wishlists = await wishlistService.getAllWishlists();
    const mappedWishlists = wishlistService.mapServerWishlistsToState(wishlists);

    if (mappedWishlists && mappedWishlists.length) {
      wishlistData.wishlists = mappedWishlists;
      wishlistData.activeWishlistId = mappedWishlists[0].id;
    }


    if (wishlistData && wishlistData.wishlists && wishlistData.wishlists.length > 0) {

      const wishlistTempleteElm = document.getElementById('wishlist__templete');
      const wishlistTemplates = wishlistTempleteElm && Handlebars.compile(
        wishlistTempleteElm.innerHTML
      );

      const wishlistSidebarElm = document.getElementById('wishlist__templete_sidebar');
      const wishlistSidebarTemplates = wishlistSidebarElm && Handlebars.compile(
        wishlistSidebarElm.innerHTML
      );

      const templateWishlistModalListsElm = document.getElementById('template-wishlist-modal__lists');
      const templatesWishlistModalLists = templateWishlistModalListsElm && Handlebars.compile(
        templateWishlistModalListsElm.innerHTML
      );

      if (wishListPage.wishlistResults && wishlistTemplates) {
        wishListPage.wishlistSidebar.innerHTML = wishlistSidebarTemplates(wishlistData);
        wishListPage.wishlistResults.innerHTML = wishlistTemplates(wishlistData);
        wishListPage.wishlistLoading.style.display = 'none';
        wishListPage.emptyContainer.style.display = 'none';
        wishListPage.container.style.display = 'block';
        wishListPage.requestQuoteActionWrapper.style.display = 'block';
      }

      if (wishListPage.wishlistModalBody && templatesWishlistModalLists) {
        wishlistData.selectedVariantId = variantId;
        wishListPage.wishlistModalBody.innerHTML = templatesWishlistModalLists(wishlistData);
      }

      if (wishlistData.selectedVariantId) {
        const wishListCheckboxes = wishListPage.wishlistModalBody.querySelectorAll('[data-wish-list-id]');

        wishListCheckboxes.forEach(function(checkbox) {
          const checkboxId = checkbox.dataset.wishListId;
          const selectedWishlists = wishlistData.wishlists.find(function(wishlist) {
            return wishlist.id === checkboxId;
          });
          const slectedVariantFromList = selectedWishlists && selectedWishlists.items.find(item => item.variantId === wishlistData.selectedVariantId);

          if (slectedVariantFromList) {
            document.querySelector(`#checkbox_${checkboxId}`).checked = true;
          };

          if (checkbox.checked) {

            checkbox.addEventListener( 'change', function() {
              if(!this.checked) {
                // Checkbox is checked..
                const wishlistId = this.dataset.wishListId;
                const selectedItem = {};

                selectedItem.variantId = window.SwymPageData.epi;
                selectedItem.productId = window.SwymPageData.empi;
                selectedItem.url = window.SwymPageData.uri;

                if (selectedItem.variantId) {
                  removeItemFromWishlist(wishlistId, selectedItem);
                }
              }
          });
          }
        });


      };

      const selectedTabId = `swym_tab_${wishlistData.wishlists[0].id}`;

      if(selectedTabId){
        showWishlistTab(selectedTabId);
      }

      const formWishlistUrl = document.getElementById('formWishlistUrl');


      if (formWishlistUrl) {
        const wishListShareLink = formWishlistUrl && `${formWishlistUrl.value}?hkey=${
          wishlistData.activeWishlistId
        }`;
        formWishlistUrl.value = wishListShareLink;
      }



    } else {
      wishListPage.wishlistLoading.style.display = 'none';
      wishListPage.emptyContainer.style.display = 'block';
      wishListPage.container.style.display = 'none';
      wishListPage.requestQuoteActionWrapper.style.display = 'none';
    }

    // updateWishNavCount(wishlists);
  };

  const showWishlistTab = (tabId) => {
    $('#wishlist__results .swym-wishlist').removeClass('active');
    $('#wishlist-sidebar li').removeClass('active');
    $(`#${tabId}`).addClass('active');
    $(`[data-wishlist-tab-id=${tabId}]`).addClass('active');
  }

  $(document).on('click', '[data-wishlist-tab-id]', function(){
    const selectedTabId = this.dataset.wishlistTabId;

    if(selectedTabId){
      showWishlistTab(selectedTabId);
      shareWishlistFormToggle("close");
    }
  });

// share Wishlist Form toggler
  const shareWishlistFormToggle = function(type){
    if (type === 'error') {
      $('[data-wishlist-share-error]').show();
      return
    }
    if (type === 'success') {
      $('[data-wishlist-share-error]').hide();
      $('[data-wishlist-share-success]').show();
      $('[data-wishlist-share-form-fields]').hide();
      return
    }

    if (type === "close") {
      $('[data-wishlist-share-form]').hide();
      $('#wishlist-request-quote_action-wrapper').show();
      return
    }

    $('[data-wishlist-share-error]').hide();
    $('[data-wishlist-share-success]').hide();
    $('[data-wishlist-share-form-fields]').show();

  };

  // get selected wishlist name
  const getSlectedWishlistName = function(){
    return $('#wishlist__results .swym-wishlist.active').attr('data-swym-wishlist-title');
  };

  // Remove item form wishlist
  const removeItemFromWishlist = async function (wishlistId, item) {
    const deleteConfirmed = confirm('Are you sure you want to remove this product?');
    if (deleteConfirmed) {
      try {
        await wishlistService.removeItemFromWishlist(wishlistId, item);
        fetchWishlists();
      } catch (e) {
        console.error('Error removing item from wishlist');
      }
    }
  };

  // Update wishlist name
  const updateWishlistName = async function (activeWishlistId, value, callback) {
    try {
      await wishlistService.updateList({
        lid: activeWishlistId,
        lname: value,
      });
      fetchWishlists();
    } catch (e) {
      console.log('Error updating wishlist name', e);
    }
  };

  // Delect wishlist
  const deleteWishlist = async function (wishlistId) {
    const deleteConfirmed = confirm('Are you sure you want to delete this Wishlist?');

    if (deleteConfirmed) {
      try {
        await wishlistService.deleteWishlist(wishlistId);
        fetchWishlists();
      } catch (e) {
        console.error('Error deleting Wishlist');
      }
    }
  };

  const shareWishlistViaEmail =  async function(formData) {
   if (!formData) {
     return null
   }

    try {
      const objectMap = {
        ...formData,
      };
      await wishlistService.sendListViaEmail(objectMap)
      shareWishlistFormToggle('success');
    } catch (e) {
      shareWishlistFormToggle('error')
      console.error(e);
    }
  };

  const selectListName = (checkboxId) => {
    document.getElementById(checkboxId).checked = true;
  }

  const createWishList = async (listName) => {
    if (!listName) {
      return null
    }
    try {
      await wishlistService.createWishList(listName).then(data =>{
        fetchWishlists();
        const checkboxId = `checkbox_${data.lid}`
        selectListName(checkboxId);
      });
    } catch (e) {
      console.error(e);
    }
   };

  $(document).on('click', '[data-share-Wishlist-email]', function () {
    const sendrName = $('#share-wishlist--name').val();
    const recipientEmail = $('#share-wishlist--recipient-email').val();
    const message = $('#ContactForm-message').val();
    // const selectedList = $(this).parents('.swym-wishlist');
    const wishlistId = $('#wishlist__results .swym-wishlist.active').attr('data-swym-wishlist-id');

    const isValid = recipientEmail !== "" ;

    if (!isValid) {
      $('[data-wishlist-share-error]').show();
      return null
    }

      const shareWishlistFormData = {
        senderName: sendrName,
        recipientEmail: recipientEmail,
        message: message,
        wishlistId: wishlistId,
      };

      shareWishlistViaEmail(shareWishlistFormData);

  });

  $(document).on('click', '[data-wishlist-modal-open]', function () {
    $('[data-wishlist-modal]').show();

  });

  $(document).on('click', '[data-wishlist-modal-close]', function () {
    $('[data-wishlist-modal]').hide();
  });

  $(document).on('click', swymActionSelector.enquiryClose, function () {
    $(swymActionSelector.enquiryWrapper).hide();
  });

  $(document).on('click', swymActionSelector.requestQuote, function () {
    $(swymActionSelector.enquiryWrapper).show();
  });

  // List Rename upadete
  $(document).on('click', swymActionSelector.listRenameUpdade, function () {
    const value = $(this).parents('.swym-wishlist').find('input').val();
    const selectedList = $(this).parents('.swym-wishlist');
    const wishlistId = selectedList.attr('data-swym-wishlist-id');

    if (value && wishlistId) {
      updateWishlistName(wishlistId, value);
    }
  });

  // PDP Add-to-wishlist

  $(document).on('click', '.js-add-to-wishlist', function(){

    const wishListCheckboxes = wishListPage.wishlistModalBody.querySelectorAll('[data-wish-list-id]');

    const listIds = [];
    wishListCheckboxes.forEach(function(checkbox){
      if (checkbox.checked) {
        const listId = checkbox.dataset.wishListId;
        listIds.push(listId);
      }
    })

    const listItemMap = {
      epi: SwymPageData.epi, // one unique list item (empi+epi) per listid
      empi: SwymPageData.empi,
      du: SwymPageData.du
    };

    if (listIds.length > 0 && listItemMap) {
      wishlistService
        .addProductToLists(listItemMap, listIds)
          .then(function (resp) {
            if (resp && resp.length) {
              setSavedToWishlistButton();
              wishlistService.getAllWishlists(); // update header total

              const item = {
                item_name: resp[0].dt,
                item_id: resp[0].sku,
                price: resp[0].pr,
                item_brand: resp[0].bt,
                item_category: window.liquid.product.type,
                item_variant: resp[0].vi || resp[0].dt,
                quantity: '1',
              };

              listIds.forEach(list => {
                window.dataLayer.push({
                  event: 'add_to_wishlist',
                  ecommerce: {
                    items: [item],
                  },
                });
              })
          
            }
          })
          .catch(function (xhrObject) {
          });        

      $('[data-wishlist-modal]').hide();
    }else{
      console.error(listIds, listItemMap)
    }

  });

  // PDP create wishlist form cancel

  $(document).on('click', '.js-swym-list-create-cancel', function(){
    $('[data-wishlist-modal-action]').show();
    $('[data-wishlist-modal-create-form]').hide();
  });


  // PDP create wishlist form
  $(document).on('click', '.wishlist-btn-creatlist', function(){
    $('[data-wishlist-modal-action]').hide();
    $('[data-wishlist-modal-create-form]').show();
  });

  // List Rename cancel
  $(document).on('click', '.js-swym-list-create', function (e) {
    const listName = $(this).parents().find('.js-swym-list-create-input').val();

    if (!listName) {
      return null
    }

    createWishList(listName);

    $('[data-wishlist-modal-action]').show();
    $('[data-wishlist-modal-create-form]').hide();

  });

  // List Rename cancel
  $(document).on('click', swymActionSelector.listRenameCancel, function (e) {
    $(swymActionSelector.header).show();
    $(swymActionSelector.headerForm).hide();
  });

  // List Rename
  $(document).on('click', swymActionSelector.listRename, function () {
    //$(swymActionSelector.header).toggle()
    $(swymActionSelector.header).hide();
    $(swymActionSelector.headerForm).show();
  });

  // List Delete
  $(document).on('click', swymActionSelector.listDelete, function () {
    const selectedList = $(this).parents('.swym-wishlist');
    const wishlistId = selectedList.attr('data-swym-wishlist-id');

    deleteWishlist(wishlistId);
  });

  // Add product to cart
  $(document).on('click', '.wishlist__btn--addToCart', function () {
    const selectedItemRow = $(this).parents('.wishlist-list__item');
    const variantId = selectedItemRow.attr('data-swym-wishlist-item-variantId');

    const formData = {
      id: variantId,
      quantity: 1,
    };

    window.theme.Product.prototype._addItemToCart(formData);
  });

  // remove product form list
  $(document).on('click', '.wishlist__btn--remove', function () {
    const selectedItemRow = $(this).parents('.wishlist-list__item');
    const selectedList = $(this).parents('.swym-wishlist');
    const wishlistId = selectedList.attr('data-swym-wishlist-id');
    const selectedItem = {};

    selectedItem.variantId = selectedItemRow.attr('data-swym-wishlist-item-variantId');
    selectedItem.productId = selectedItemRow.attr('data-swym-wishlist-item-productId');
    selectedItem.url = selectedItemRow.attr('data-swym-wishlist-item-url');

    removeItemFromWishlist(wishlistId, selectedItem);
  });

  // Wishlist share
  $(document).on('click', '[data-wishlist-share-close]', function () {
    shareWishlistFormToggle("close");
  })

  $(document).on('click', '.js-wishlist-share', function () {
    const selectedListName = getSlectedWishlistName();

    $('#wishlist-request-quote_action-wrapper').hide();
    $('[data-wishlist-share-form]').show();
    $('[data-wishlist-share-success]').hide();
    $('[data-wishlist-share-error]').hide();
    $('[data-wishlist-share-form-fields]').show();
    $('[data-wishlist-share-form] [data-set-selected-wishlist]').text(selectedListName);
  });


  if (wishListPage.wishlistResults || wishListPage.wishlistModal) {
    fetchWishlists();
  }
});
